import { render, staticRenderFns } from "./PessoaMultiselect.vue?vue&type=template&id=c974a67a"
import script from "./PessoaMultiselect.vue?vue&type=script&lang=js"
export * from "./PessoaMultiselect.vue?vue&type=script&lang=js"
import style0 from "./PessoaMultiselect.vue?vue&type=style&index=0&id=c974a67a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports